import { render, staticRenderFns } from "./DimensionEditor.vue?vue&type=template&id=1ea0b60b&scoped=true"
import script from "./DimensionEditor.vue?vue&type=script&lang=js"
export * from "./DimensionEditor.vue?vue&type=script&lang=js"
import style0 from "./DimensionEditor.vue?vue&type=style&index=0&id=1ea0b60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea0b60b",
  null
  
)

export default component.exports